import type { ApolloError } from '@apollo/client';
import * as Sentry from '@sentry/react';
import type { Extras } from '@sentry/types';

type ErrorSource = string;

type Message = {
  error: ApolloError | Error;
  source?: ErrorSource | '';
  extra?: Extras;
  level?: Sentry.SeverityLevel;
  /**
   * Allows us to filter for errors on specific Coach modes
   */
  coachMode?: string;
  coachAction?: string;
  tags?: Record<string, string>;
};

/**
 * Capture messages in Sentry with the Coach prefix which enables us to filter for errors
 * related to Coach platform which we can target for slack alerts.
 * See https://coursera.sentry.io/alerts/rules/ondemand/15386162
 */
export const captureMessageInSentry = ({
  error,
  source = '',
  level = 'error',
  coachMode,
  coachAction,
  extra = {},
  tags = {},
}: Message) => {
  const sourceString = source ? `[${source}]` : '';

  try {
    Sentry.captureMessage(`[AiCoachPlatform]: ${sourceString} ${error.toString()}`, {
      level,
      extra: {
        error,
        ...extra,
      },
      tags: {
        ...(coachMode && { coachMode }),
        ...(coachAction && { coachAction }),
        ...tags,
      },
    });
  } catch {
    // eslint-disable-next-line no-console
    console.error('[AiCoachPlatform]: Unable to capture this exception in Sentry', { error });
  }
};
